import * as React from "react";

import { Autocomplete, FormControl, FormHelperText, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import { FormState, UseFormSetValue } from "react-hook-form/dist/types";

import { compareGroups } from "src/domain/administrative/resource-management/features/templates/utils/groupSort";

interface GroupInputProps {
  formState: FormState<any>;
  templateGroups: string[];
  groups: Group[];
  setValue: UseFormSetValue<any>;
}

const Row = styled("div")(() => ({
  marginBottom: "30px",
  display: "flex",
  justifyContent: "space-between",
}));

export const GroupInput: React.FC<GroupInputProps> = ({ formState, templateGroups, groups, setValue }) => {
  const sortedGroups = React.useMemo(() => {
    if (!groups) {
      return [];
    }

    const sorted = groups.sort((a, b) => compareGroups(a, b));
    return sorted.map((group) => group.name);
  }, [groups]);

  const handleChange = (event, value) => {
    setValue("groups", value);
  };

  return (
    <Row>
      <FormControl
        sx={{
          width: "100%",
        }}
      >
        <Autocomplete
          multiple
          data-testid={`groups-select`}
          id={`groups-input-select`}
          options={sortedGroups}
          onChange={handleChange}
          defaultValue={templateGroups}
          getOptionLabel={(option) => option}
          renderInput={(params) => <TextField {...params} label="User Groups" placeholder="" />}
        />
        <FormHelperText>
          {formState.errors?.groups
            ? formState.errors?.groups?.message
            : groups?.length > 0
            ? "Select User Groups"
            : "No User Groups Available"}
        </FormHelperText>
      </FormControl>
    </Row>
  );
};
